import { FIXED_STEP_MS } from './config';

/** Fixed-timestep accumulator. Call tick(deltaMs) once per frame; it invokes step for each fixed step. */
export class FixedStepper {
  private acc = 0;
  public steps = 0;
  constructor(private readonly stepMs = FIXED_STEP_MS, private readonly maxStepsPerFrame = 5) {}
  tick(deltaMs: number, step: (dtMs: number) => void): void {
    this.acc += Math.min(deltaMs, this.stepMs * this.maxStepsPerFrame);
    let n = 0;
    while (this.acc >= this.stepMs && n < this.maxStepsPerFrame) {
      step(this.stepMs);
      this.acc -= this.stepMs;
      this.steps++;
      n++;
    }
    if (n === this.maxStepsPerFrame) this.acc = 0; // drop backlog after a stall
  }
  reset(): void { this.acc = 0; }
}
